module.exports = __webpack_public_path__ + "static/img/riz.e760386.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/riz.jpg
// module id = OdXc
// module chunks = 5